import api from '@/api/index.js'

const system_account = {
  state: {
    loading: false,
    updating: false,
    single: null, // Represents single retrieved SystemAccount or newly created.
    error: null
  },

  mutations: {
    SET_SYSTEM_ACCOUNT_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_SYSTEM_ACCOUNT: (state, single) => {
      state.single = single;
      state.loading = false;
    },
    SET_SYSTEM_ACCOUNT_ERROR: (state, error) => {
      if (!error) {
        state.error = null;
        return
      }

      state.error = error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText;
      state.loading = false;
      state.updating = false;
    },
    SET_SYSTEM_ACCOUNT_UPDATING: (state, updating) => {
      state.updating = updating
    },
  },

  actions: {
    CreateSystemAccount({commit}, payload) {
      commit('SET_SYSTEM_ACCOUNT_UPDATING', true);
      commit('SET_SYSTEM_ACCOUNT_ERROR', null)
      return api.post(`system-accounts`, payload)
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNT', response.body)
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNT_ERROR', error);
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false);
        })
    },
    GetSystemAccount({commit}, id) {
      commit('SET_SYSTEM_ACCOUNT', null)
      commit('SET_SYSTEM_ACCOUNT_LOADING', true);
      commit('SET_SYSTEM_ACCOUNT_ERROR', null)
      return api.get(`system-accounts/${id}`)
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNT', response)
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNT_ERROR', error);
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    UpdateSystemAccount({commit}, payload) {
      commit('SET_SYSTEM_ACCOUNT_UPDATING', true);
      commit('SET_SYSTEM_ACCOUNT_ERROR', null)
      return api.put(`system-accounts/${payload.id}`, payload)
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNT_ERROR', error);
        })
    },
    UpdateSystemAccountToken({commit}, payload) {
      commit('SET_SYSTEM_ACCOUNT_UPDATING', true);
      commit('SET_SYSTEM_ACCOUNT_ERROR', null)
      return api.put(`system-accounts/${payload.id}/token`, payload.data)
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNT', response.body)
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNT_ERROR', error);
        })
    },
    DeleteSystemAccount({commit}, id) {
      commit('SET_SYSTEM_ACCOUNT_UPDATING', true);
      commit('SET_SYSTEM_ACCOUNT_ERROR', null)
      return api.delete(`system-accounts/${id}`)
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNT_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false);
        })
    },
    InviteSystemAccount({commit}, id) {
      commit('SET_SYSTEM_ACCOUNT_UPDATING', true);
      commit('SET_SYSTEM_ACCOUNT_ERROR', null)
      return api.put(`system-accounts/${id}/invitation`)
        .then((response) => {
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SYSTEM_ACCOUNT_ERROR', error);
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText);
          commit('SET_SYSTEM_ACCOUNT_UPDATING', false);
        })
    }
  }
}

export default system_account
